import { drawImage } from './images.js'
import { getGameplayEdges, player } from './game.js'
import Player from './player.js'

class Enemy extends Player {
    constructor(x, y) {
        super(x, y)

        this.w = 10
        this.h = 12
        this.damage = 0.1
        this.speed = 0.1

        this.maxHp = 5
        this.hp = this.maxHp
        this.xp = 1

        this.character = 'Slime'
        this.state = 'Idle'
        this.particleImage = 'Slime-Particle'

        this.stats.loot = [
            { odds: 0.01, drop: 'rare-chest' },
            { odds: 0.15, drop: 'chest' },
            { odds: 0.25, drop: 'gem' },
        ]
    }

    AnimationFrame(frame) {
        if (frame !== undefined) {
            this.animationFrame = frame
        }
        return parseInt(this.animationFrame)
    }

    ShouldAnimationPlay() {
        return true
    }

    AnimationAdvance(delta) {
        if (!this.ShouldAnimationPlay()) {
            return parseInt(this.animationFrame)
        }
        this.animationFrame += delta * this.animationSpeed
        if (this.animationFrame > this.animationFramesCount) {
            this.animationFrame = 0
            if (['Attack', 'Hurt'].includes(this.state)) {
                this.SetAnimation('Idle')
            }
        }
        return parseInt(this.animationFrame)
    }

    SetAnimation(state) {
        this.state = state
        this.animationFrame = 0
    }

    Draw(offsetx, offsety) {
        drawImage(this.character + '-' + this.state, parseInt(this.x + offsetx - this.w / 2), parseInt(this.y + offsety - this.h / 2), { x: this.AnimationFrame() * this.w, y: 0, w: this.w, h: this.h }, this.flipped)
    }

    Damage(amt) {
        if (this.state === 'Hurt' || this.dead) {
            return
        }
        
        this.hp -= amt
        this.SetAnimation('Hurt')
        if (this.hp <= 0) {
            this.hp = 0
            if (!this.dead) {
                this.dead = true
            }
        }
    }

    Update(delta) {
        this.AnimationAdvance(delta)

        if (this.dead) {
            return
        }

        // let dx = this.movement.x * delta * this.speed
        // let dy = this.movement.y * delta * this.speed

        let dist = Math.sqrt( Math.pow((player.x - this.x), 2) + Math.pow((player.y - this.y), 2) )
        if (dist > 3) {
            let dx = player.x - this.x
            let dy = player.y - this.y
            let angle = Math.atan2(dy, dx)
            let velX = Math.cos(angle) * this.speed
            let velY = Math.sin(angle) * this.speed
            
            this.x += velX
            this.y += velY
        }

        // Apply force vector to position.
        let fx = this.force.x * delta * this.stats.knockback.melee.speed
        let fy = this.force.y * delta * this.stats.knockback.melee.speed

        this.x += fx
        this.y += fy

        // Flip sides if we went off-screen.
        let edges = getGameplayEdges()
        if (this.y < edges.top) {
            this.y = edges.bottom
        }
        if (this.y > edges.bottom) {
            this.y = edges.top
        }
        if (this.x < edges.left) {
            this.x = edges.right
        }
        if (this.x > edges.right) {
            this.x = edges.left
        }

        this.ApplyFriction()

        // TODO: If melee/projectile/area cooldown is > 0, decrement by delta time.
        
        // let index = CoordinatesToTileIndex(parseInt(this.x / tileset.tilewidth), parseInt(this.y / tileset.tileheight))
        // let tileIndex = currentLevel.layers[0].data[index] - 1
        // let baseTile = tileset.tiles.filter(f => f.id === tileIndex)
        // if (baseTile.length > 0 && baseTile[0].class === 'Water') {
        //     this.standingInWater = true
        // } else {
        //     this.standingInWater = false
        // }

        // TODO: If melee/projectile/area active is > 0, apply damage to enemies in range and decrement by delta time.
        // TODO: If melee/projectile/area active == 0, set cooldown to duration.

    }
}

export default Enemy